<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="dedicationpage">
<a id="page09">
<p class="dedicationText"><em class="italic">This book is for Amanda Peters</em></p>
</a></div>
<a id="page09">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003dedicationpage.vue?3e6ed5d1